import { Icons } from '@agro-club/agroclub-shared'
import { isRussia, isUS } from 'env'
import { EventModel } from 'modules/socket/types'
import BidRoutes from 'views/pages/Bid/routes'
import CallsRoutes from 'views/pages/Calls/routes'
import CallStatisticsRoutes from 'views/pages/CallStatistics/routes'
import CompanyRoutes from 'views/pages/Company/routes'
import { ContractsRoutes } from 'views/pages/Contracts/routes'
import DashboardRoutes from 'views/pages/Dashboard/routes'
import DealRoutes from 'views/pages/Deal/routes'
import DispatchingRoutes from 'views/pages/Dispatching/routes'
import { DocIndexRoutes } from 'views/pages/DocIndex/routes'
import { DocumentRequestsRoutes } from 'views/pages/DocumentRequests/routes'
import ElevatorRoutes from 'views/pages/Elevators/routes'
import ExportRoutes from 'views/pages/Export/routes'
import CarriersKRRoutes from 'views/pages/LogisticsKR/CarriersKR/routes'
import CarsKRRoutes from 'views/pages/LogisticsKR/CarsKR/routes'
import CustomersKRRoutes from 'views/pages/LogisticsKR/CustomersKR/routes'
import DealsKRRoutes from 'views/pages/LogisticsKR/LogisticRequests/routes'
import PaymentOrdersRoutes from 'views/pages/LogisticsKR/PaymentOrders/routes'
import RatesRoutes from 'views/pages/LogisticsKR/Rates/routes'
import WarehousesKRRoutes from 'views/pages/LogisticsKR/WarehousesKR/routes'
import MatchesRoutes from 'views/pages/Matches/routes'
import TasksRoutes from 'views/pages/MyTasks/routes'
import ReportsRoutes from 'views/pages/Reports/routes'
import SamplesRoutes from 'views/pages/Samples/routes'
import { SdizRoutes } from 'views/pages/Sdiz/routes'
import SellerPotentialRoutes from 'views/pages/SellerPotential/routes'
import SpecificationsRoutes from 'views/pages/Specifications/routes'
import TeamsRoutes from 'views/pages/Teams/routes'
import UsContractsRoutes from 'views/pages/us/UsContracts/routes'
import UsersRoutes from 'views/pages/User/routes'
import WarehousesRoutes from 'views/pages/Warehouses/routes'
import WhatsAppRoutes from 'views/pages/WhatsApp/routes'

export const defaultRoute = DashboardRoutes.Root

export const OPTIONS = {
  MATCHES: {
    key: MatchesRoutes.List,
    translateKey: 'matches',
    icon: <Icons.IconBrickView />,
    access: { permission: 'users.view_menu_dashboard', extra: false },
  },
  SIGMA_DPR: {
    key: ReportsRoutes.DPR,
    translateKey: 'dpr',
    icon: <Icons.IconChartline />,
    access: { permission: 'users.view_menu_dashboard', extra: isUS },
  },
  SIGMA_PL: {
    key: ReportsRoutes.PL,
    translateKey: 'pl',
    icon: <Icons.IconChartline />,
    access: { permission: 'users.view_menu_dashboard', extra: isUS },
  },
  SIGMA_DAILY: {
    key: ReportsRoutes.Daily,
    translateKey: 'dailyReport',
    icon: <Icons.IconChartline />,
    access: { permission: 'users.view_menu_dashboard', extra: isUS },
  },
  SIGMA_NEW_CONTRACTS: {
    key: ReportsRoutes.NewContracts,
    translateKey: 'newContracts',
    icon: <Icons.IconChartline />,
    access: { permission: 'users.view_menu_dashboard', extra: isUS },
  },
  SIGMA_UNSHIPPED: {
    key: ReportsRoutes.Unshipped,
    translateKey: 'unshippedReport',
    icon: <Icons.IconChartline />,
    access: { permission: 'users.view_menu_dashboard', extra: isUS },
  },
  DASHBOARD: {
    key: DashboardRoutes.Root,
    translateKey: 'dashboard',
    icon: <Icons.IconDashboard />,
    access: { permission: 'users.view_menu_dashboard', extra: isRussia },
  },
  MY_TASKS: {
    key: TasksRoutes.List,
    translateKey: 'myTasks',
    icon: <Icons.IconMatch />,
    access: { permission: 'users.view_menu_tasks', extra: isRussia },
    eventModel: 'task' as const,
  },
  TEAMS: {
    key: TeamsRoutes.List,
    translateKey: 'teams',
    icon: <Icons.IconTeams />,
    access: { permission: 'users.view_menu_teams', extra: isRussia },
  },
  COMPANIES: {
    key: CompanyRoutes.List,
    translateKey: 'companies',
    icon: <Icons.IconCompanies />,
    access: { permission: 'users.view_menu_companies', extra: true },
  },

  USERS: {
    key: UsersRoutes.List,
    translateKey: 'users',
    icon: <Icons.IconRetailer />,
    access: { permission: 'users.view_menu_users', extra: true },
  },
  BIDS: {
    key: BidRoutes.List,
    translateKey: 'bids',
    icon: <Icons.IconDescription />,
    access: { permission: 'users.view_menu_bids', extra: true },
  },
  DEALS: {
    key: DealRoutes.List,
    translateKey: 'deals',
    icon: <Icons.IconDeals />,
    access: { permission: 'users.view_menu_deals', extra: !isUS },
  },
  US_CONTRACTS: {
    key: UsContractsRoutes.List,
    translateKey: 'usContracts',
    icon: <Icons.IconDeals />,
    access: { permission: 'users.view_menu_contracts', extra: isUS },
  },
  WAREHOUSES: {
    key: WarehousesRoutes.List,
    translateKey: 'warehouses',
    icon: <Icons.IconGarage />,
    access: { permission: 'users.view_menu_warehouses', extra: isRussia },
  },
  ELEVATORS: {
    key: ElevatorRoutes.List,
    translateKey: 'elevators',
    icon: <Icons.IconGarage />,
    access: { permission: 'users.view_menu_warehouses', extra: true },
  },
  LOGISTICS_DASHBOARD: {
    key: DealsKRRoutes.List,
    translateKey: 'logisticsDashboard',
    icon: <Icons.IconDescription />,
    access: { permission: 'users.view_menu_new_logistics_requests', extra: isRussia },
    eventModel: ['tripoffer', 'tripdocument'] as EventModel[],
  },
  CARRIERS: {
    key: CarriersKRRoutes.List,
    icon: <Icons.IconRetailer />,
    translateKey: 'carriers',
    access: { permission: 'users.view_menu_new_logistics_carriers', extra: isRussia },
  },
  CARS: {
    key: CarsKRRoutes.List,
    translateKey: 'cars',
    icon: <Icons.IconShipping />,
    access: { permission: 'users.view_menu_new_logistics_cars', extra: isRussia },
  },
  RATES: {
    key: RatesRoutes.List,
    translateKey: 'rates',
    icon: <Icons.IconCalculator />,
    access: { permission: 'users.view_menu_logistics_rates', extra: !isUS },
  },
  PAYMENT_ORDERS: {
    key: PaymentOrdersRoutes.List,
    translateKey: 'paymentOrders',
    icon: <Icons.IconCalculator />,
    access: { permission: 'users.view_menu_new_logistics_payment_orders', extra: isRussia },
  },
  CUSTOMERS: {
    key: CustomersKRRoutes.List,
    translateKey: 'customers',
    icon: <Icons.IconRetailer />,
    access: { permission: 'users.view_menu_new_logistics_customers', extra: isRussia },
  },
  ADDRESSES: {
    key: WarehousesKRRoutes.List,
    translateKey: 'addresses',
    icon: <Icons.IconAddress />,
    access: { permission: 'users.view_menu_new_logistics_warehouses', extra: isRussia },
  },
  DISPATCHING: {
    key: DispatchingRoutes.List,
    translateKey: 'dispatching',
    icon: <Icons.IconShippingDone />,
    access: { permission: 'users.view_menu_deals_dispatching', extra: isRussia },
  },
  EXPORT: {
    key: ExportRoutes.List,
    translateKey: 'export',
    icon: <Icons.IconShip />,
    access: { permission: 'users.view_menu_export', extra: isRussia },
  },
  CALLS_LIST: {
    key: CallsRoutes.List,
    translateKey: 'callsList',
    icon: <Icons.IconPhone />,
    access: { permission: 'users.view_menu_calls_list', extra: isRussia },
  },
  WHATS_APP: {
    key: WhatsAppRoutes.List,
    translateKey: 'whatsApp',
    icon: <Icons.IconWhatsapp />,
    access: { permission: 'users.view_menu_calls_statistics', extra: false },
  },
  CALL_STATISTICS: {
    key: CallStatisticsRoutes.List,
    translateKey: 'callStatistics',
    icon: <Icons.IconPhoneOut />,
    access: { permission: 'users.view_menu_calls_statistics', extra: isRussia },
  },
  SPECIFICATIONS: {
    key: SpecificationsRoutes.List,
    icon: <Icons.IconOrders1 />,
    translateKey: 'specifications',
    access: { permission: 'users.view_menu_specifications', extra: isRussia },
  },
  SAMPLES: {
    key: SamplesRoutes.List,
    icon: <Icons.IconSampling />,
    translateKey: 'samples',
    access: { permission: 'users.view_menu_samples', extra: isRussia },
  },

  DOCUMENTS_LIST: {
    key: DocumentRequestsRoutes.List,
    translateKey: 'documentsList',
    icon: <Icons.IconAttach />,
    access: { permission: 'users.view_menu_documents_requests', extra: isRussia },
    eventModel: 'documentsrequest' as const,
  },
  CONTRACTS: {
    key: ContractsRoutes.List,
    translateKey: 'contracts',
    icon: <Icons.IconSign />,
    access: { permission: 'users.view_menu_sale_contract_requests', extra: isRussia },
    eventModel: 'salecontractrequest' as const,
  },
  SDIZ: {
    key: SdizRoutes.List,
    translateKey: 'sdiz',
    icon: <Icons.IconPickup />,
    access: { permission: 'users.view_menu_sdizes', extra: isRussia },
  },
  SELLER_POTENTIAL: {
    key: SellerPotentialRoutes.List,
    translateKey: 'sellerPotential',
    icon: <Icons.IconTrialSeed />,
    access: { permission: 'users.view_menu_company_product_data_analytics', extra: true },
  },
  DOC_INDEX: {
    key: DocIndexRoutes.List,
    translateKey: 'docIndex',
    icon: <Icons.IconAttach />,
    access: { permission: 'docs_index.view_documentindex', extra: true },
  },
}
